import TypedLocalStore from "typed-local-store"

type Schema = {
  user: {
    jwt: string
    id: number
  }
}

export const localStorage = new TypedLocalStore<Schema>()
